export default __webpack_public_path__ + "static/media/050_brake.58f575c8.mp4";